import React from 'react';
import { DifficultyLevel } from '../types';

export interface DifficultySelectorProps {
  value: DifficultyLevel;
  onChange: (difficulty: DifficultyLevel) => void;
  className?: string;
}

const DIFFICULTY_OPTIONS = [
  {
    level: 'easy' as DifficultyLevel,
    name: 'Easy',
    description: 'Mostly easy questions',
    icon: '😊'
  },
  {
    level: 'medium' as DifficultyLevel,
    name: 'Medium',
    description: 'Balanced mix',
    icon: '🤔'
  },
  {
    level: 'hard' as DifficultyLevel,
    name: 'Hard',
    description: 'Challenging questions',
    icon: '🔥'
  }
];

/**
 * DifficultySelector component allows users to choose quiz difficulty level
 * Provides three difficulty options: Easy, Medium, Hard
 */
export const DifficultySelector: React.FC<DifficultySelectorProps> = ({
  value,
  onChange,
  className = ''
}) => {
  const handleDifficultySelect = (difficulty: DifficultyLevel) => {
    onChange(difficulty);
  };

  return (
    <div className={className}>
      <h3 className="text-sm font-medium text-neutral-900 mb-3">Difficulty Level</h3>

      {/* Difficulty Options */}
      <div className="space-y-2">
        {DIFFICULTY_OPTIONS.map((option) => (
          <button
            key={option.level}
            onClick={() => handleDifficultySelect(option.level)}
            className={`w-full text-left p-3 rounded-lg border transition-colors ${value === option.level
                ? 'border-primary-400 bg-primary-50'
                : 'border-neutral-200 bg-neutral-50 hover:border-primary-300'
              }`}
          >
            <div className="flex items-center gap-2">
              <span className="text-lg">{option.icon}</span>
              <div>
                <div className="font-medium text-neutral-900">{option.name}</div>
                <div className="text-sm text-neutral-600">{option.description}</div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};